<template>
    <v-card
            class="mx-auto"
            min-height="200"
            flat
    >
            <v-layout wrap>
                <v-flex xs12>
                    <v-card-text class="py-0">
                        <v-text-field v-model="search" prepend-inner-icon="search" clearable label="Buscar" />
                        <v-sheet height="300" style="overflow-y: auto"  v-prevent-parent-scroll>
                          <div class="text-center" v-if="loading" >
                            <v-progress-circular indeterminate color="primary" width="2" size="40" class="mt-4"/>
                          </div>
                          <template v-else>
                            <div v-if="exams.length === 0" class="pa-3 text-center">
                              <div>Debes configurar esta sección para utilizarla.</div>
                              <div>
                                <v-btn rounded small depressed color="primary" :to="{name: 'panel.provider.settings', query: {view: 'ClinicalRecord'}}">
                                  <v-icon left size="16">fa-cog</v-icon>
                                  Ir a la configuración
                                </v-btn>
                              </div>
                            </div>
                            <v-slide-y-transition>
                              <v-treeview
                                  v-show="!loading"
                                  v-model="tree"
                                  :active.sync="active"
                                  activatable
                                  :items="exams"
                                  :search="search"
                                  :filter="filter"
                                  :open.sync="open"
                                  class="text-left"
                                  open-on-click
                                  return-object
                                  hover
                              >
                                <template v-slot:prepend="{ item, open }">
                                  <v-icon
                                      v-if="item.children && item.children.length > 0"
                                      :color="(open ? 'primary' : 'secondary')"
                                  >{{ open ? 'mdi-folder-open' : 'mdi-folder' }}</v-icon>

                                  <v-icon v-else :color="locked && locked.includes(item.id) ? 'grey lighten-1' : (active.find(exam => exam.id === item.id) ? 'accent' : 'secondary')">
                                    fas fa-file-prescription
                                  </v-icon>
                                </template>
                              </v-treeview>
                            </v-slide-y-transition>
                          </template>

                        </v-sheet>
                    </v-card-text>

                </v-flex>

            </v-layout>
        <physical-exam-form :event-id="eventId" ref="physicalExamForm" @attach="onExamAttach" />
    </v-card>
</template>

<script>

    import ExamForm from '@/components/appointments/attention/ExamForm'
    import PhysicalExamForm from '@/components/appointments/attention/physical_exams/PhysicalExamForm'

    import {ApiUtils} from '@/utils/ApiUtils'
    import {mapState, mapMutations} from 'vuex'

    export default {
        components: {ExamForm, PhysicalExamForm},
        props: ['eventId', 'locked'],
        data: () => ({
            loading: false,
            loadingAttach: false,
            active: [],
            tree: [],
            exams: [],
            open: [1],
            search: null,
            caseSensitive: false
        }),
        mounted(){
            this.getAvailableExams()
        },
        methods: {
                ...mapMutations(['showSnackBar']),
            onExamAttach(exam){
                this.showSnackBar('Exámen agregado correctamente')
                this.active = []
                this.$emit('attach', exam)
            },
            onExamSelect(exam){

                var vm = this
                vm.selectedExam = exam
            },
            async getAvailableExams(){
                var vm = this

                if(vm.loading || !vm.currentProvider) return

                vm.loading = true
                const response = await ApiUtils.makeGet(`providers/${vm.currentProvider.id}/exams/physical`)
                vm.loading = false

                if(!response.ok){
                    const json = await response.json()
                    vm.showSnackBar(json.message || 'Ha ocurrido un error intentando consultar examenes')
                    return
                }

                const json = await response.json()
                vm.exams = json.result.physical_exams

            }
        },
        watch:{
            open(val){

            },
            selectedExam(val){
                var vm = this
                if(!val) return
                if(vm.locked && vm.locked.includes(val.id)){
                    vm.showSnackBar({
                        text:'Este exámen ya fue agregado',
                        color: 'error'
                    })
                    vm.active = []
                    return
                }

                vm.$refs.physicalExamForm.show(JSON.parse(JSON.stringify(val)))
                setTimeout(function(){
                    vm.active = []
                }, 100)

            }
        },
        computed: {
                ...mapState(['currentProvider']),
            selectedExam(){
                var vm = this
                if (!vm.active.length) return undefined
                return this.active[0]
            },
            filter () {
                return this.caseSensitive
                        ? (item, search, textKey) => item[textKey].indexOf(search) > -1
                        : undefined
            }
        }
    }
</script>
